module.exports = __webpack_public_path__ + "fepro/img/guide_table.6c15faf8.png";